var ModalWindow = function ModalWindow(_ref) {
  var children = _ref.children,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "fullscreen",
    onClick: function onClick(e) {
      if (_onClick && e.target.className === 'fullscreen') _onClick();
    }
  }, children);
};
export default ModalWindow;